import * as React from "react";
import Modal from "react-bootstrap/Modal";
import Draggable from "react-draggable";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import { tagNameDelimiter } from "../helpers";

interface Props {
  onModalStateChange: (isVisible: boolean) => void;
  displayTagName: string;
  tagNames: string[];
  onSubmit: (tagsArray: string[]) => void;
}

interface State {
  closeFocus: boolean;
  tagNames: string[];
}

export class IndividualTagsModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      closeFocus: false,
      tagNames: this.props.tagNames
    };
  }

  handleUpdateButtonClicked = () => {
    this.props.onSubmit(this.state.tagNames);
    this.props.onModalStateChange(false);
  };

  onMouseEnter = () => {
    this.setState({
      closeFocus: true
    });
  };

  onMouseLeave = () => {
    this.setState({
      closeFocus: false
    });
  };

  onUpdateTags = (e: React.ChangeEvent<HTMLInputElement>, tagIndex: number) => {
    const tagNames = [ ...this.state.tagNames];
    tagNames[tagIndex] = e.target.value;
    this.setState({ tagNames });
  }

  render() {
    const closeClass = this.state.closeFocus
      ? "ui-dialog-titlebar-close ui-corner-all ui-state-hover"
      : "ui-dialog-titlebar-close ui-corner-all";

    return (
      <Modal
        show={true}
        animation={false}
        centered={true}
        onEscapeKeyDown={() => this.props.onModalStateChange(false)}
        onHide={() => {
          /* don't allow hide via off-click*/
        }}
        size="sm"
        enforceFocus={true}
        style={{
          zIndex: 10001, background: "rgba(000, 000, 000, 0.5)"
        }}
      >
        <Draggable
          axis="both"
          handle=".ui-dialog-titlebar"
        >
          <div
            id="CcfModal"
            className="ui-dialog ui-widget ui-widget-content ui-corner-all ui-draggable"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="ui-dialog-title-ccfaction3"
            style={{
              display: "block",
              zIndex: 10002,
              outline: "0px",
              height: "auto",
              width: "350px",
            }}
          >
            <div className="ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix">
              <span className="ui-dialog-title" id="ui-dialog-title-ccfaction3">
                Specify tags for {this.props.displayTagName}
              </span>
              <div className={closeClass}>
                <span
                  className="ui-icon ui-icon-closethick"
                  style={{ cursor: "pointer" }}
                  onMouseEnter={this.onMouseEnter}
                    onMouseLeave={this.onMouseLeave}
                    onClick={() => this.props.onModalStateChange(false)}
                  >
                  close
                </span>
              </div>
            </div>
            <div
              id="ccfaction3"
              className="ui-dialog-content ui-widget-content"
              style={{
                display: "block",
                width: "auto",
                minHeight: "0px"
              }}
            >
            <div>
              {(this.state.tagNames).map((tagName, i) => {
                return (
                  <input
                    style={{ width: "100%", marginBottom: "5px" }}
                    key={i}
                    onChange={e => this.onUpdateTags(e, i)}
                    type="text"
                    value={tagName} />
                );
              })}              
            </div>
            <div className="update-button-div" style={{ marginTop: "3px" }}>
              <input
                type="submit"
                value="Update"
                className="green-button"
                onClick={this.handleUpdateButtonClicked}
              />
            </div>
            </div>
          </div>
        </Draggable>
      </Modal>
    );
  }
}
